/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

export enum MonitoringEntryDtoSource {
  FRIDGE_INCIDENT = "FRIDGE_INCIDENT",
  HOT_HOLDING_ALERT = "HOT_HOLDING_ALERT",
  LOG_READING = "LOG_READING",
  CHECK_FAILURE = "CHECK_FAILURE",
  FIRE_EXTINGUISHER_ITEM = "FIRE_EXTINGUISHER_ITEM",
  EMERGENCY_LIGHT_ITEM = "EMERGENCY_LIGHT_ITEM",
  FIRE_DRILL = "FIRE_DRILL",
}
